import React from "react";
import { default as MuiListItemButton } from "@mui/material/ListItem";

function ListItemButton(props) {
  return <MuiListItemButton {...props} />;
}

export default ListItemButton;
